(function(){
  function norm(s){ return (s||'').toString().toLowerCase().trim(); }
  function run(){
    var form=document.getElementById('dealerSearchForm');
    if(!form) return;
    var input=document.getElementById('dealerSearchInput');
    var msg=document.getElementById('dealerSearchMsg');
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var q=norm(input&&input.value);
      if(msg){ msg.style.display='none'; }
      if(!q) return;
      var data=(window.STENS_DEALERS_DATA&&window.STENS_DEALERS_DATA.countries)||{};
      var hit=null;
      Object.keys(data).forEach(function(code){
        if(hit) return;
        var c=data[code]||{};
        if(code===q || norm(c.name).indexOf(q)>-1){ hit=code; return; }
        (c.dealers||[]).forEach(function(d){
          if(hit) return;
          if(norm(d.city).indexOf(q)>-1 || norm(d.name).indexOf(q)>-1 || norm(d.address).indexOf(q)>-1){ hit=code; }
        });
      });
      if(hit){ window.location.href='/pages/dealer?country='+encodeURIComponent(hit); }
      else if(msg){ msg.textContent='No authorized dealer found for "'+input.value+'". Try a country or city name.'; msg.style.display='block'; }
    });
  }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
})();
